import React from 'react';
import { Clock, CheckCircle2, Loader2, Users, Flag } from 'lucide-react';

const TurnStatusBar = ({ multiState, onVoteEnd }) => {
  if (!multiState) return null;

  const { players = [], turn_phase, current_turn, timer_warning, your_submitted } = multiState;
  const activePlayers = players.filter(p => !p.is_eliminated);
  const submittedCount = activePlayers.filter(p => p.has_submitted).length;
  const totalActive = activePlayers.length;

  return (
    <div className="flex items-center gap-3 px-4 py-2 bg-slate-800/60 backdrop-blur-sm border-b border-slate-700 text-sm">
      {/* Turn number */}
      <div className="flex items-center gap-1.5 text-slate-300">
        <span className="font-mono font-bold text-blue-400">T{current_turn}</span>
      </div>

      <div className="w-px h-4 bg-slate-600" />

      {/* Phase indicator */}
      {turn_phase === 'resolving' ? (
        <div className="flex items-center gap-1.5 text-amber-400">
          <Loader2 className="w-4 h-4 animate-spin" />
          <span>Résolution en cours...</span>
        </div>
      ) : (
        <>
          {/* Submissions count */}
          <div className="flex items-center gap-1.5">
            <Users className="w-4 h-4 text-slate-400" />
            <span className="text-slate-300">
              <span className="font-bold text-white">{submittedCount}</span>
              /{totalActive} prêts
            </span>
          </div>

          {/* Player submission status */}
          {your_submitted ? (
            <div className="flex items-center gap-1 text-green-400">
              <CheckCircle2 className="w-4 h-4" />
              <span>Soumis</span>
            </div>
          ) : (
            <div className="flex items-center gap-1 text-slate-400">
              <Clock className="w-4 h-4" />
              <span>En attente</span>
            </div>
          )}
        </>
      )}

      {/* Timer warning */}
      {timer_warning && timer_warning <= 30 && (
        <>
          <div className="w-px h-4 bg-slate-600" />
          <div className={`flex items-center gap-1 font-mono font-bold ${
            timer_warning <= 10 ? 'text-red-400 animate-pulse' : 'text-amber-400'
          }`}>
            <Clock className="w-4 h-4" />
            <span>{timer_warning}s</span>
          </div>
        </>
      )}

      {/* Vote end button */}
      {onVoteEnd && !multiState.active_vote && turn_phase !== 'resolving' && totalActive >= 2 && (
        <>
          <div className="w-px h-4 bg-slate-600" />
          <button
            onClick={() => onVoteEnd('initiate')}
            className="flex items-center gap-1 px-2 py-0.5 rounded text-xs text-slate-300 hover:text-amber-300 hover:bg-slate-700/50 transition-colors"
          >
            <Flag className="w-3.5 h-3.5" />
            Voter fin
          </button>
        </>
      )}

      {/* Player dots */}
      <div className="ml-auto flex items-center gap-1">
        {activePlayers.map((p) => (
          <div
            key={p.username}
            title={`${p.username} (${p.country_short_name || '?'})`}
            className={`w-2.5 h-2.5 rounded-full transition-colors ${
              p.has_submitted
                ? 'bg-green-400'
                : p.is_connected === false
                  ? 'bg-red-400'
                  : 'bg-slate-500'
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default TurnStatusBar;
